<template>
    <div class="hello">
        <h1>{{ $t('site.common.thankYou') }}</h1>
        Thanks for your help in translating ElvenStats.

        <div class="row">
            <div class="col-md-8">
                <v-alert outline color=info icon=info :value="true">
                   April 7th, 2018 - I added some new features to the site which required some new language strings.  I have not yet
                    made them available in collabedit.  Turns out we've outgrown collabedit's 25,000 character limit so i'll need to find
                    a new solution for this.  Stay tuned.
                </v-alert>
            </div>
        </div>

        <div class="row">
            <div class="col-md-7">
        <h2>Instructions</h2>
        1. For the language you want to translate go to the appropriate link:
        <br-simple-table :items="languageTable" :headers="['locale','link','status','credits']"></br-simple-table>

        <p>
        2. Edit the file.  This is a collaborative link (similar to google docs) so you can share this with other people such as your fellowship members and you can work
            on it together!  <strong>Do not feel you need to translate everything!</strong> Let's not make perfect be the enemy of good here.
            I have added some comments indicating the most important points.
        </p>

        <p>
            3. <strong>Optional</strong>, We have created the ability to preview your translations live on <a href="http://dev.elvenstats.com">http://dev.elvenstats.com</a>.
            Simply click on your language above the avatar and this <b>special version of ElvenStats</b> that will download the translations from collabedit and inject them into the site automatically!
        </p>
            </div>
        </div>

        <h2>Demo</h2>
        <img width=700 src="https://www.dropbox.com/s/m7xr7gkm09tcoc8/translationHowTo.gif?dl=1">

        <h2>Important Notes</h2>
        Here are a few important things to keep in mind.
        <ol style="margin-left:40px">
            <li>You want to edit the quoted strings (they appear in blue).  In the course of editing, you will probably delete a quote and perhaps the comma at the end.
            This isn't a big deal (i'll fix it when I import your changes), just know that if you try and view your changes on the site and it fails.  This is the likely reason.
            <li>Some things have a variable placeholders in them.  They are in curly brackets like: <code>{0}</code> or <code>{1}</code> or <code>{username}</code><br/>
                <code style="padding-top:5px; padding-bottom:5px">tourneyChamp: " - Tourney Champ (this week): {0}",</code>
                <br/>
                Do not translate them and make sure you keep them in there.  They can be moved within the sentence if appropriate for the language.
            </li>
            <li>Try to keep translations the same length or shorter.</li>
            <li>If you spend a lot of time on here, please backup your work but copy and pasting the entire text blob into something like an email or text file.
            The site does save history on the history tab so this shouldn't be a real issue (unless someone clicks PURGE HISTORY... that would be terrible).
            </li>
        </ol>
    </div>
</template>

<script>
    import translationData from '../lib/translation-data';
    import BrSimpleTable from "@/components/BRSimpleTable";
    export default {
        components: { BrSimpleTable },
        name: 'Thanks',
        data () {
            return {
                languageTable: translationData.getLinks()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/TranslatationInstructions.vue